import React from "react";
import { MessageCircle, Code2 } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";

const PHONE = "07701270365";

export const DeveloperCard = () => {
  const { lang } = usePrefs();
  const ar = lang === "ar";
  return (
    <div data-testid="developer-card" className="rounded-3xl border bg-card p-4 flex items-center gap-3">
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-accent"><Code2 className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1">
        <p className="text-xs text-muted-foreground">{ar ? "مطوّر النظام" : "Developer"}</p>
        <p data-testid="developer-name" className="font-bold">{ar ? "رعد الغبان" : "Raad Al-Ghabban"}</p>
      </div>
      <a data-testid="developer-whatsapp" href={`https://wa.me/964${PHONE.slice(1)}`} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 px-3 py-2 text-sm font-bold text-white transition-transform hover:scale-105" dir="ltr">
        <MessageCircle className="h-4 w-4" />{PHONE}
      </a>
    </div>
  );
};
